export default __webpack_public_path__ + "ch-treasure-chest.icon-8288cc4adfcebc7a721242b03ab1c317.png";